import React from "react";
import SpotProductDTO from "features/contracts/dtos/SpotProductDTO";
import PageCard from "features/shared/components/card/PageCard";
import InfoItem from "features/shared/components/infoItem/InfoItem";
import { useTranslation } from "react-i18next";
import { formatNumber } from "features/shared/helpers/Formatters";

type Props = {
  spotProduct: SpotProductDTO;
};

const ContractSpotProductCard = ({ spotProduct }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // helpers
  const renderCoefficient = () => {
    if (spotProduct.coefficient) {
      return (
        <div className="col-sm px-sm-3">
          <InfoItem
            title={tLabels("contractSpotProductCard.coefficient")}
            value={formatNumber(spotProduct.coefficient, 2)}
          />
        </div>
      );
    }
  };

  const renderConstant = () => {
    if (spotProduct.constant) {
      return (
        <div className="col-sm px-sm-3">
          <InfoItem
            title={tLabels("contractSpotProductCard.constant")}
            value={formatNumber(spotProduct.constant, 2)}
          />
        </div>
      );
    }
  };

  // render
  return (
    <PageCard title={tLabels("contractSpotProductCard.cardTitle")}>
      <div className="row no-gutters">
        <div className="col-sm px-sm-3">
          <InfoItem
            title={tLabels("contractSpotProductCard.spotFormulaName")}
            value={spotProduct.spotFormulaName}
          />
        </div>
        {renderCoefficient()}
        {renderConstant()}
        <div className="col-sm px-sm-3">
          <InfoItem
            title={tLabels("contractSpotProductCard.spotBaseName")}
            value={spotProduct.spotBaseName}
          />
        </div>
      </div>
    </PageCard>
  );
};

export default ContractSpotProductCard;
